import ToolTip from "../toolTip";
import arrow from '@assets/whiteArrow.svg';
import './index.scss'

export default function Index({title,tips}:{
    title:string,
    tips:string
}){
    return  <div className='card-head'>
    <div className='title'>
        {title}<ToolTip title={tips} />
    </div> 
</div>
}